import React, { Component } from 'react';
import UploadButton from './UploadButton';
import { Example, Properties, SourceCode } from 'examples';

export default class UploadButtonExample extends Component {

  state = {};

  onChange = e => this.setState(e.target.value);

  onUpload = e => this.setState({ uri: e.target.value });

  render() {
    const { uri, ...rest } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={UploadButton.defaultProps} propTypes={UploadButton.propTypes} propValues={this.state}/>
        <div className="buttons">
          <UploadButton className="primary" {...rest} onUpload={this.onUpload} data-location="test"/>
          <UploadButton onUpload={this.onUpload} disabled={rest.disabled}/>
          <UploadButton className="tertiary" onUpload={this.onUpload} disabled={rest.disabled}/>
        </div>
        <p><strong>URI: {uri}</strong></p>
        <SourceCode querySelector=".core-upload-button"/>
      </Example>
    );
  }

}
